import { useState, useRef, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPaperclip,
  faPaperPlane,
  faUserCircle,
  faTimesCircle,
  faFile,
  faArrowLeft,
} from "@fortawesome/free-solid-svg-icons";

const ChatWindow = ({ messages, onSend, currentUserId, selectedUser ,setSelectedUser,}) => {
  const [message, setMessage] = useState("");
  const [file, setFile] = useState(null);
  const messagesEndRef = useRef(null);

  useEffect(() => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [messages]);

  const handleSend = () => {
    if (!message.trim() && !file) return;
    onSend({ text: message.trim(), file });
    setMessage("");
    setFile(null);
  };

  const handleFileSelect = (e) => {
    const selected = e.target.files[0];
    if (selected) setFile(selected);
  };

  const handleRemoveFile = () => {
    setFile(null);
  };

  const isSendDisabled = !message.trim() && !file;



  return (
    <div className="h-screen w-full  bg-white  flex flex-col overflow-hidden">
      {/* Header */}
      <div className="flex items-center justify-between bg-gradient-to-r from-indigo-600 to-indigo-500 text-white px-6 py-4">
        <div className="flex items-center space-x-3">

              <button onClick={() => setSelectedUser(null)} className="mr-2">
              <FontAwesomeIcon icon={faArrowLeft} className="text-xl" />
            </button>

          <FontAwesomeIcon icon={faUserCircle} className="text-4xl" />
          <div style={{lineHeight:1}}>
            <h2 className="text-xl font-semibold">{selectedUser?.name || "User"} </h2>
            <p className="text-sm">{selectedUser?.role}</p>
          </div>
        </div>
      </div>

      {/* Chat Body */}
      <div className="flex-1 overflow-y-auto px-6 py-4 bg-gray-50">
        {messages.map((msg, index) => {
          const isCurrentUser = msg.senderId === currentUserId;
          return (
            <div
              key={index}
              className={`mb-4 flex ${isCurrentUser ? "justify-end" : "justify-start"}`}
            >
              <div
                className={`max-w-[60%] px-4 py-3 rounded-2xl shadow-sm ${
                  isCurrentUser
                    ? "bg-indigo-500 text-white rounded-br-none"
                    : "bg-gray-200 text-gray-900 rounded-bl-none"
                }`}
              >
                {msg.fileUrl ? (
                  <div>
                    <a
                      href={`https://bpohasil.ngrok.app${msg.fileUrl}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={`block underline font-medium ${
                        isCurrentUser
                          ? "hover:text-indigo-200"
                          : "hover:text-gray-700"
                      }`}
                    >
                      <FontAwesomeIcon icon={faFile}/> {msg.fileName || "View File"}
                    </a>
                    {msg.message && <p className="mt-1">{msg.message}</p>}
                  </div>
                ) : (
                  <span>{msg.message}</span>
                )}
                <div
                  className={`text-xs mt-1 ${
                    isCurrentUser ? "text-indigo-100" : "text-gray-500"
                  }`}
                >
                  {msg.time || ""}
                </div>
              </div>
            </div>
          );
        })}
        <div ref={messagesEndRef} />
      </div>

      {/* File Preview (if selected) */}
      {file && (
        <div className="px-6 py-2 border-t bg-gray-100 flex items-center justify-between">
          <div className="flex items-center space-x-2 text-gray-700">
            <FontAwesomeIcon icon={faPaperclip} className="text-indigo-500" />
            <span className="truncate max-w-[200px] text-sm font-medium">
              {file.name}
            </span>
          </div>
          <button
            onClick={handleRemoveFile}
            className="text-gray-400 hover:text-red-500 transition"
          >
            <FontAwesomeIcon icon={faTimesCircle} />
          </button>
        </div>
      )}

      {/* Input Area */}
      <div className="border-t bg-white px-6 py-3 flex items-center space-x-3">
        {/* File Upload */}
        <label className="cursor-pointer text-gray-600 hover:text-indigo-500 transition">
          <FontAwesomeIcon icon={faPaperclip} size="lg" />
          <input
            type="file"
            className="hidden"
            onChange={handleFileSelect}
          />
        </label>

        {/* Text Input */}
        <input
          type="text"
          className="flex-1 bg-gray-100 rounded-full px-4 py-2 outline-none text-gray-700 placeholder-gray-400 focus:ring-2 focus:ring-indigo-400"
          placeholder="Type a message..."
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && !isSendDisabled && handleSend()}
        />

        {/* Send Button */}
        <button
          onClick={!isSendDisabled ? handleSend : undefined}
          disabled={isSendDisabled}
          className={`rounded-full px-4 py-2 transition ${
            isSendDisabled
              ? "bg-gray-300 text-gray-500 cursor-not-allowed"
              : "bg-indigo-500 hover:bg-indigo-600 text-white cursor-pointer"
          }`}
        >
          <FontAwesomeIcon icon={faPaperPlane} />
        </button>
      </div>
    </div>
  );
};

export default ChatWindow;
